import { render } from "./AppHeader.vue?vue&type=template&id=be48c71e&scoped=true"
const script = {}

import "./AppHeader.vue?vue&type=style&index=0&id=be48c71e&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be48c71e"]])

export default __exports__